import { oneOf } from 'prop-types';
import {
  topics,
  overviewSubTopics,
  performanceSubTopics,
  chartsSubTopics,
  airplaySubTopics,
  socialSubTopics,
  audienceSubTopics,
} from 'topics';

const toValue = (topic) => topic.value;

export default oneOf([
  ...topics,
  ...overviewSubTopics.map(toValue),
  ...performanceSubTopics.map(toValue),
  ...chartsSubTopics.map(toValue),
  ...airplaySubTopics.map(toValue),
  ...socialSubTopics.map(toValue),
  ...audienceSubTopics.map(toValue),
]);
